<template>
  <KioskCenteredLayout
    :class="$style.confirmationPage"
    :style="backgroundStyle"
  >

    <div :class="$style.confirmationContent">
      <div :class="$style.checkmark">
        <svg v-svg
             :class="$style.checkmarkIcon"
             symbol="checkmark-icon" />
      </div>
      <KioskMessageTitle
        :class="$style.confirmationTitle"
        title="We're preparing your order!"
      />
      <p :class="$style.confirmationText">
        We will call your name when it is ready.
      </p>
      <BaseButton
        :class="$style.ghostBtn"
        @click="handleDone">
        Done
      </BaseButton>
    </div>
  </KioskCenteredLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action } from 'vuex-class';
import background from '@/assets/img/blur-bg-kiosk.jpg';
import KioskCenteredLayout from '@/layouts/KioskCenteredLayout';
import BaseButton from '@/components/BaseButton';
import KioskMessageTitle from '@/components/KioskMessageTitle';
import { AUTH_LOGOUT } from '@/apps/auth/store/types';

/**
 * Provide confirmation page
 */
@Component({
  components: {
    KioskCenteredLayout,
    BaseButton,
    KioskMessageTitle,
  },
})
export default class KioskConfirmation extends Vue {
  @Action(AUTH_LOGOUT) logout;

  get backgroundStyle() {
    return { 'background-image': `url(${background})` };
  }

  handleDone() {
    this.logout();
    this.$router.push({ name: 'main' });
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';
$bg: rgba(#050504, 0.7);

.confirmationPage {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}

.confirmationContent {
  position: relative;
  z-index: 3;
}

.checkmark {
  width: 260px;
  height: 260px;
  background-color: $white;
  border-radius: 50%;
  margin: 0 auto;
  .checkmarkIcon {
    fill: $green-color;
    width: 260px;
    height: 260px;
  }
}

.confirmationTitle {
  margin-top: 88px;
  margin-bottom: 18px;
}

.confirmationText {
  color: $white;
  font-size: 34px;
  line-height: 48px;
  text-align: center;
  margin-bottom: 140px;
}

.confirmationContent .ghostBtn {
  display: block;
  width: 650px;
  height: 100px;
  margin: 0 auto;
  border: 3px solid $green-color;
  border-radius: 50px;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.5);
  div {
    color: $white;
    font-size: 30px;
    line-height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskConfirmation.vue